import EstimateGrossProfit from '../../pages/policy/estimate'
/**
 * 广告账户下载异常的路由配置。
 *
 * 如何访问"流程详情"路由：
 * this.$router.push({name: 'CustomerWorkflowDetail', params: {flowType: t, flowId: id}})
 */

export default [
  {
    name: 'EstimateGrossProfit',
    path: '/estimate-gross-profit',
    meta: { title: '预估毛利' },
    component: EstimateGrossProfit
  }
]
